import LandingHeader from "./LandingHeader";
import LandingHero from "./LandingHero";
import LandingReadiness from "./LandingReadiness";
import LandingWorkflow from "./LandingWorkflow";

import "./LandingExperience.css";

interface LandingExperienceProps {
  onRequestAccess: (source: string) => void;
}

export default function LandingExperience({ onRequestAccess }: LandingExperienceProps) {
  return (
    <div className="oc-landing" id="top">
      <LandingHeader onRequestAccess={() => onRequestAccess("header")} />
      <main>
        <LandingHero onRequestAccess={() => onRequestAccess("hero")} />
        <LandingWorkflow />
        <LandingReadiness onRequestAccess={() => onRequestAccess("rollout")} />
      </main>
    </div>
  );
}
